import {
  Autocomplete,
  Box,
  ListItemText,
  TextField,
  createFilterOptions,
} from "@mui/material";
import allAddress from "../../data/addressWithZone.json";
import { useTranslation } from "react-i18next";
import { forwardRef, useState } from "react";

const allAddressType = allAddress;

const AddressRenderOption = ({ props, option, type }) => {
  return (
    <li {...props} key={props.id} value={option[type]}>
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box display="flex">
          <ListItemText
            primary={option.sub_district}
            primaryTypographyProps={{
              style: {
                fontWeight: type === "sub_district" ? 600 : 400,
              },
            }}
          />
          <ListItemText
            primary={option.district}
            primaryTypographyProps={{
              style: {
                fontWeight: type === "district" ? 600 : 400,
                textAlign: "right",
              },
            }}
          />
        </Box>
        <Box display="flex">
          <ListItemText
            primary={option.province}
            primaryTypographyProps={{
              style: {
                fontWeight: type === "province" ? 600 : 400,
              },
            }}
            secondary={option.zone}
            secondaryTypographyProps={{
              style: {
                fontWeight: type === "zone" ? 600 : 400,
                fontSize: 16,
                color: "#000000",
              },
            }}
          />
          <ListItemText
            primary={option.postal_code}
            primaryTypographyProps={{
              style: {
                fontWeight: type === "postal_code" ? 600 : 400,
                textAlign: "right",
              },
            }}
          />
        </Box>
      </Box>
    </li>
  );
};
const CustomizedAddressBox = forwardRef(
  (
    {
      type,
      value,
      onChange,
      disabled,
      error,
      helperText,
      onInputChange,
      required,
    },
    ref
  ) => {
    const filterOptions = createFilterOptions({
      matchFrom: "any",
      limit: 100,
      stringify: (option) => {
        const optionString = `${option.province} ${option.sub_district} ${option.district} ${option.zone} ${option.postal_code}`;
        return optionString;
      },
    });

    const [open, setOpen] = useState(false);

    const { t } = useTranslation();
    return (
      <Autocomplete
        ref={ref}
        disabled={disabled}
        value={value}
        onChange={onChange}
        filterOptions={filterOptions}
        freeSolo
        disableClearable
        getOptionLabel={(option) => option[type] || ""}
        options={allAddressType}
        onInputChange={(event, value) => {
          if (event) setOpen(true);
          if (onInputChange) onInputChange(value);
        }}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        renderOption={(props, option) => (
          <AddressRenderOption
            key={props.id}
            props={props}
            option={option}
            type={type}
          />
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={t(`contact.address.${type}`)}
            InputProps={{
              ...params.InputProps,
            }}
            error={error}
            helperText={helperText}
            required={required}
          />
        )}
      />
    );
  }
);

export default CustomizedAddressBox;
